import { atom } from 'jotai';

type CustomerioState =
  | { status: 'loading' }
  | { status: 'ready' }
  | { status: 'idle' }
  | { status: 'error'; errorMessage: string };

export const customerioStateAtom = atom<CustomerioState>({ status: 'idle' });
